import $ from 'jquery';
import { chain, filter, find, findWhere, forEach } from 'underscore';
import videojs from 'video.js';

// @ts-expect-error TSMIGRATION
import controlsTemplate from 'bundles/videojs/layout/controls.html';
import 'bundles/videojs/plugins/subtitlesMenu';
import 'bundles/videojs/plugins/subtitlesMenuItem';
import 'bundles/videojs/plugins/subtitlesOffMenuItem';

import _t from 'i18n!nls/videojs';

const KEY_UP_ARROW = 38;
const KEY_DOWN_ARROW = 40;
const KEY_ENTER = 13;
const KEY_SPACE = 32;
const SELECTED_CLASS = 'vjs-selected';
const HIDDEN_CLASS = 'vjs-hidden';

class SubtitlesMenuButton extends videojs.getComponent('SubtitlesButton') {
  constructor(player: $TSFixMe, options: Record<string, unknown> & { defaultSubtitleLanguage?: string } = {}) {
    // @ts-expect-error
    super(player, options);
    const label = _t('Subtitles');
    const {
      // @ts-expect-error TSMIGRATION
      menuButton_,
      // @ts-expect-error TSMIGRATION
      menu,
    } = this;
    menuButton_.el_.innerHTML = '<span class="cif-2x cif-fw cif-captions"></span>';
    menuButton_.el_.innerHTML += `<span class="vjs-control-text">${label}</span>`;
    menuButton_.el_.setAttribute('aria-label', label);
    menuButton_.addClass('vjs-control');
    menuButton_.addClass('c-vjs-button');
    menuButton_.el_.removeAttribute('aria-live');

    if (options.defaultSubtitleLanguage) {
      menu.showSubtitleOffItem();
    } else {
      menu.hideSubtitleOffItem();
    }

    this.one(
      player,
      'ready',
      // @ts-expect-error TSMIGRATION
      () => {
        forEach(player.textTracks(), (track) => {
          /* eslint-disable no-param-reassign */
          if (track.language === options.defaultSubtitleLanguage) {
            track.mode = 'showing';
          } else {
            track.mode = 'hidden';
          }
          /* eslint-enable no-param-reassign */
        });
      }
    );
  }

  createEl() {
    const el = super.createEl();
    const $el = $(el);
    $el.attr('data-js', 'subtitles-menu-button');
    $el.addClass('c-video-control c-subtitles-control vjs-menu-button-popup');
    return el;
  }

  handleKeyPress(e: KeyboardEvent) {
    if ([KEY_UP_ARROW, KEY_DOWN_ARROW, KEY_ENTER, KEY_SPACE].includes(e.keyCode)) {
      const {
        // @ts-expect-error TSMIGRATION
        menu,
      } = this;
      const children = filter(menu.children_, (one) => !one.hasClass(HIDDEN_CLASS));
      const selected = find(children, (one) => one.hasClass(SELECTED_CLASS));

      if (!selected) {
        menu.showSubtitleOffItem();
        menu.children()[0].selected(true);
      }

      this.el().classList.add('selected');
      menu.lockShowing();
      menu.focus();

      e.preventDefault();
      e.stopPropagation();
    }
  }

  handleClick() {
    const { player_ } = this;
    player_.controlBar.subtitlesMenuButton.menu.unlockShowing();
    const tracks = player_.textTracks();
    const showingTrack = findWhere(tracks, { mode: 'showing' });

    if (showingTrack) {
      showingTrack.mode = 'disabled';
    } else if (tracks.length) {
      const defaultTrack = findWhere(tracks, { default: true });

      if (defaultTrack) {
        defaultTrack.mode = 'showing';
      } else {
        const enTrack = findWhere(tracks, { language: 'en' });

        if (enTrack) {
          enTrack.mode = 'showing';
        } else {
          tracks[0].mode = 'showing';
        }
      }
    }
  }

  createMenu() {
    const { player_, options_ } = this;
    const SubtitlesMenu = videojs.getComponent('SubtitlesMenu');
    const menu = new SubtitlesMenu(player_, options_.subtitlesMenu);

    const items = this.createItems();
    items.forEach((item) =>
      menu
        // @ts-expect-error TSMIGRATION
        .addItem(item)
    );
    // @ts-expect-error TSMIGRATION
    this.items = items;

    const refNode = menu.contentEl().children[0] || null;

    menu.contentEl().insertBefore(
      $(
        controlsTemplate({
          controlName: 'subtitlesMenuTitle',
        })
      )[0],
      refNode
    );

    menu.contentEl().insertBefore(
      $(
        controlsTemplate({
          controlName: 'menuDivider',
        })
      )[0],
      refNode
    );

    return menu;
  }

  // Create menu items for every available text track.
  createItems() {
    const player = this.player_;
    const SubtitlesOffMenuItem = videojs.getComponent('SubtitlesOffMenuItem');
    const subtitlesOff = new SubtitlesOffMenuItem(player, {
      // @ts-expect-error - TS-MIGRATION
      kind: 'subtitles',
      id: 'subtitles-off',
    });

    subtitlesOff.hide(); // hide it by default

    const SubtitlesMenuItem = videojs.getComponent('SubtitlesMenuItem');
    return [subtitlesOff].concat(
      chain(player.textTracks())
        .filter(function (track: $TSFixMe) {
          return track.kind === 'subtitles';
        })
        .sortBy('label')
        .map(function (track: $TSFixMe) {
          return new SubtitlesMenuItem(player, {
            // @ts-expect-error - TS-MIGRATION
            track,
            selectable: true,
          });
        }, this)
        .value()
    );
  }
}

videojs.registerComponent('SubtitlesMenuButton', SubtitlesMenuButton);
